import React from 'react';
import { LogoManager } from '../../components/admin/LogoManager';
import { FaviconManager } from '../../components/admin/FaviconManager';
import { ChangePasswordForm } from '../../components/admin/ChangePasswordForm';

const Settings = () => {
  return (
    <div className="space-y-6">
      {/* Logo Settings */}
      <div className="bg-white shadow rounded-lg">
        <LogoManager />
      </div>

      {/* Favicon Settings */}
      <div className="bg-white shadow rounded-lg p-6">
        <FaviconManager />
      </div>

      {/* Site Settings */}
      <div className="bg-white shadow rounded-lg p-6">
        <h2 className="text-xl font-semibold text-primary-900 mb-4">
          Site Settings
        </h2>
        <div className="space-y-4">
          <div>
            <label htmlFor="siteName" className="block text-sm font-medium text-primary-700">
              Site Name
            </label>
            <input
              type="text"
              id="siteName"
              name="siteName"
              defaultValue="Ridgeline Homes"
              className="mt-1 block w-full rounded-md border-primary-300 shadow-sm focus:border-accent-500 focus:ring-accent-500"
            />
          </div>
          <div>
            <label htmlFor="siteDescription" className="block text-sm font-medium text-primary-700">
              Site Description
            </label>
            <textarea
              id="siteDescription"
              name="siteDescription"
              rows={3}
              defaultValue="Premium residential homebuilder creating exceptional living spaces."
              className="mt-1 block w-full rounded-md border-primary-300 shadow-sm focus:border-accent-500 focus:ring-accent-500"
            />
          </div>
          <div>
            <label htmlFor="contactEmail" className="block text-sm font-medium text-primary-700">
              Contact Email
            </label>
            <input
              type="email"
              id="contactEmail"
              name="contactEmail"
              defaultValue="info@ridgelinehomes.com"
              className="mt-1 block w-full rounded-md border-primary-300 shadow-sm focus:border-accent-500 focus:ring-accent-500"
            />
          </div>
        </div>
        <div className="mt-6">
          <button
            type="button"
            className="btn btn-primary"
          >
            Save Changes
          </button>
        </div>
      </div>

      <ChangePasswordForm />
    </div>
  );
};

export default Settings; 